module.exports = __webpack_public_path__ + "img/body-type.5f37eec2.svg";